export default __webpack_public_path__ + "static/media/django-square-1.8de2bb14.svg";